import React, { useState, useEffect } from "react";
import "./BinDetails.css";
import DataTable from "../../../shared/components/DataTable/DataTable";
import BarCode from "../../BarCode/BarCode";
import { Col, Row } from "antd";

const BinDetails = (props) => {
  const {
    modalContent: {
      modalBody: { BinCode },
    },
  } = props;
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [binInfo, setBinInfo] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    setSelectedValue(BinCode);
    setBinInfo(props?.modalContent?.modalBody?.BinInfo);
    let _binData = props?.modalContent?.modalBody?.BinData;
    const _columns = [
      {
        title: "Code",
        dataIndex: "docLocation",
        key: "docLocation",
      },
      { title: "Product Name", dataIndex: "ProductName", key: "ProductName", algin: "center" },
      { title: "Order Number", dataIndex: "orderNumber", key: "orderNumber", algin: "center" },
      { title: "Machine Id / Serial", dataIndex: "MachineId", key: "MachineId", render: (text) => <span>{text || "NA"}</span> },
      { title: "Quantity", dataIndex: "Quantity", key: "Quantity" },
      {
        title: "Category",
        dataIndex: "Category",
        key: "Category",
        // render: (text) => <Tag color={categoryColors[text]} text={text} />,
      },
    ];
    setColumns(_columns);
    const _rows = props?.modalContent?.modalBody?.BinData?.map((item) => {
      return {
        ProductName: item?.product_name,
        MachineId: item?.machine_id ? item?.machine_id : "NA",
        Quantity: item?.quantity,
        Category: item?.category_name,
        docLocation: item?.doc_location,
        orderNumber: item?.order_number ? item?.order_number : "NA",
      };
    });
    setRows(_rows);
  }, [props.modalContent]);

  return (
    <div className="bin-details-container">
      <Row gutter={24}>
        <Col span={6}>
          <div className="bin-details-wrapper">
            <div className="bin-header-wrapper">
              <div className="bin-barcode-wrapper">
                <div className="barCode-actions">
                  {/* <Select style={{ width: "100%" }} placeholder="Select a person" defaultValue={BinCode} options={lookup} onChange={onChangeLookup} /> */}
                </div>
                <BarCode text={selectedValue} showActions={true} />
              </div>
            </div>

            <Row gutter={30} className="bin-labelGroup">
              {binInfo?.map((item, index) => (
                <>
                  <Col span={12}>
                    <div className="bin-labelGroup">
                      <label className="label">{item.label}</label>
                      <h1 className="display-value">{item.value}</h1>
                    </div>
                  </Col>
                </>
              ))}
            </Row>
          </div>
        </Col>
        <Col span={18}>
          <div className="bin-content-wrapper">
            <div className="products-wrapper">
              <div className="product">
                <DataTable columns={columns} rows={rows} pageSize={10} />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BinDetails;
